// Dizzplace - okno „Sprawdz dostawe pod swoj adres" (Figma 1283:3190).
//
// Zyje w DWOCH miejscach, ale w motywie jest JEDNO - ten sam wezel:
//   1. jako DRUGI KROK szuflady koszyka (Figma 1339:3175) - szuflada przenosi
//      je do swojego gniazda i wtedy okno traci zaciemnienie, uchwyt i krzyzyk;
//   2. jako osobne okno na stronie Kontakt (kafel „Sprawdz dostawe" oraz
//      „Umow spotkanie", ktore od razu wchodzi w kalendarz).
//
// Brama przed dodaniem do koszyka ZOSTALA ZDJETA 21 wrzesnia 2026: pytanie
// o adres nie zatrzymuje juz zakupu, tylko stoi na drodze do kasy w kroku 2.
// Nie przywracaj `window.dizzDostawa.brama` - szuflada nie ma go czym wolac.
//
// Skad werdykt (od 26 pazdziernika 2026, AUD-03): przy koszyku z towarem ze
// STAWEK SKLEPU dla adresu (/cart/shipping_rates.json) - tych samych, ktore
// pokaze kasa, wiec okno nie obieca czegos innego niz kasa. Jest stawka =
// dowozimy z kwota, pusta lista = nie dowozimy. Stawka techniczna „Standard”
// (99 EUR, tylko dla aplikacji Google, w kasie chowa ja SMART Checkout Rules)
// jest pomijana tak samo jak w kasie. Pusty koszyk (strona Kontakt) albo sklep
// bez odpowiedzi = werdykt z uslugi dostawy (/sprawdz). Bloki krajow w sekcji
// daja juz tylko FORMATY kodow i przyklady do komunikatu - zakresy kodow nie
// decyduja o niczym (usluga ma wlasny zapas).
//
// Kraj bierzemy z aktywnego rynku (Liquid wpisuje go do bloku danych), bo
// projekt ma JEDNO pole - kod pocztowy. Kraj spoza obslugiwanej listy zawsze
// oddaje „nie dowozimy" razem z magazynami do odbioru osobistego.
//
// To INFORMACJA, nie blokada: kto nie dostaje dowozu, umawia sie na odbior
// w magazynie i kupuje dalej.

(() => {
  const KLUCZ = 'dizz_dostawa';
  const KLUCZ_KOD = 'dizz_dostawa_kod';

  /* Ile trwa potwierdzenie „Dodaje" przed oddaniem pola szufladzie koszyka.
     Tyle, zeby klient zdazyl przeczytac zielona ramke, i nie wiecej. */
  const CZAS_POTWIERDZENIA = 600;

  /* Po umowionej wizycie okno zamyka sie samo - tyle, zeby klient zobaczyl
     zielone potwierdzenie, i ani chwili dluzej. */
  const CZAS_POTWIERDZENIA_WIZYTY = 1000;

  /* Najdluzej tyle czekamy na usluge dostawy (pierwsza trasa dla kodu idzie
     przez Google Maps); dluzej = werdykt po kraju, jak przed usluga. */
  const CZAS_USLUGI = 6000;

  // W trybie prywatnym sessionStorage potrafi rzucac wyjatkiem przy kazdym
  // dotknieciu - wtedy pamiec podreczna strony wystarczy, zeby okno nie
  // wyskakiwalo przy kazdym kolejnym produkcie w tej samej odslonie.
  let pamiec = false;

  const juzBylo = () => {
    if (pamiec) return true;
    try {
      return sessionStorage.getItem(KLUCZ) === '1';
    } catch (e) {
      return false;
    }
  };

  const zapamietaj = () => {
    pamiec = true;
    /* Ta sama klasa co w <head>: kalkulator wysylki w szufladzie koszyka
       pyta o to samo, wiec po sprawdzeniu adresu znika z oczu. Klasa siedzi
       na <html>, wiec przezywa kazde przerysowanie szuflady przez Section
       Rendering API. */
    document.documentElement.classList.add('dostawa-sprawdzona');
    try {
      sessionStorage.setItem(KLUCZ, '1');
    } catch (e) { /* tryb prywatny przegladarki */ }
  };

  /* ---------- stany magazynow dla koszyka ---------- */

  /* Kasa Shopify pozwala na odbior osobisty tylko w magazynie, ktory ma na
     stanie CALY koszyk. Stan wariantu w poszczegolnych magazynach oddaje
     widok `?view=odbior` (templates/product.odbior.liquid) - przy pozycjach
     koszyka Liquid tej listy nie wypelnia. Wynik trzymamy na cala odslone
     strony, bo stany nie zmieniaja sie z minuty na minute. */
  const stanyWariantow = new Map();

  const stanWariantu = (pozycja) => {
    const id = String(pozycja.variant_id);
    if (!stanyWariantow.has(id)) {
      const adres = `/products/${encodeURIComponent(pozycja.handle)}?variant=${id}&view=odbior`;
      /* BEZ naglowka `Accept: application/json` - z nim Shopify ignoruje
         `view` i oddaje swoj JSON produktu, w ktorym stanow magazynow nie ma. */
      const obietnica = fetch(adres)
        .then((odpowiedz) => (odpowiedz.ok ? odpowiedz.json() : Promise.reject()))
        .then((dane) => dane.miasta || {})
        .catch(() => {
          stanyWariantow.delete(id);
          return null;
        });
      stanyWariantow.set(id, obietnica);
    }
    return stanyWariantow.get(id);
  };

  /* Oddaje funkcje „czy magazyn w tym miescie ma caly koszyk" albo null, gdy
     stanow nie da sie ustalic (blad sieci, pusty koszyk). Przy null niczego
     nie blokujemy - pewna odpowiedz i tak da kasa. */
  const magazynyZKoszykiem = async () => {
    let koszyk;
    try {
      /* Z prefiksem jezyka strony - bez niego Shopify oddawal tytuly pozycji
         w jezyku domyslnym domeny i kafle odbioru na /en, /de i /pl mowily
         po niderlandzku (audyt na slepo 27.10.2026). */
      const korzen = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const odpowiedz = await fetch(`${korzen}cart.js`, { headers: { Accept: 'application/json' } });
      if (!odpowiedz.ok) return null;
      koszyk = await odpowiedz.json();
    } catch (e) {
      return null;
    }
    const pozycje = [];
    const widziane = new Set();
    (koszyk.items || []).forEach((pozycja) => {
      if (widziane.has(pozycja.variant_id)) return;
      widziane.add(pozycja.variant_id);
      pozycje.push(pozycja);
    });
    if (!pozycje.length) return null;
    /* Najpierw te same dane co dopisek „Na stanie: ...” w kroku 1 (usluga
       stanow, `window.dizzStany`), zeby oba kroki mowily to samo. Usluga nie
       odpowie - zapasem jest widok `?view=odbior`. Wariant bez limitu
       (niesledzony) jest wszedzie. */
    let stany = null;
    const zUslugi = window.dizzStany && window.dizzStany.stany
      ? await window.dizzStany.stany(pozycje.map((p) => p.variant_id))
      : null;
    if (zUslugi) {
      stany = zUslugi.map((w) =>
        w.stan === null
          ? null
          : Object.fromEntries(w.magazyny.map((m) => [String(m.miasto).trim().toLowerCase(), w.stan[m.uchwyt] === true])),
      );
    } else {
      const zWidoku = await Promise.all(pozycje.map(stanWariantu));
      if (zWidoku.some((stan) => stan === null)) return null;
      stany = zWidoku;
    }
    const jest = (stan, miasto) => stan === null || stan[miasto] === true;
    const czyMa = (miasto) => Boolean(miasto) && stany.every((stan) => jest(stan, miasto));
    /* Kazdy wzor z koszyka z „dostepny / niedostepny” w tym magazynie - do
       listy na kaflu. Sama nazwa wzoru, bez opisu po myslniku („Cloud Ivory – Panel scienny
       PVC 280x122 cm” -> „Cloud Ivory”). */
    const krotka = (tytul) => {
      const pelna = String(tytul || '').trim();
      const czesc = pelna.split(/\s[–—-]\s/)[0].trim();
      /* Myslnik w nawiasie to nie granica nazwy („Montagelijm (polymeer - 600 ml)”
         ucinalo sie w pol nawiasu, audyt 26.10.2026). */
      return czesc.split('(').length === czesc.split(')').length ? czesc : pelna;
    };
    /* Probka i plyta tego samego wzoru maja ta sama krotka nazwe - wtedy obie
       ida z pelnym tytulem, inaczej klient nie wie, ktora jest „niedostepna”. */
    const pelneTytuly = new Map();
    pozycje.forEach((p) => {
      const k = krotka(p.product_title);
      if (!pelneTytuly.has(k)) pelneTytuly.set(k, new Set());
      pelneTytuly.get(k).add(String(p.product_title || '').trim());
    });
    const nazwaPozycji = (tytul) => {
      const k = krotka(tytul);
      return pelneTytuly.get(k) && pelneTytuly.get(k).size > 1 ? String(tytul || '').trim() : k;
    };
    czyMa.pozycje = (miasto) => {
      const wynik = new Map();
      pozycje.forEach((p, i) => {
        const nazwa = nazwaPozycji(p.product_title);
        wynik.set(nazwa, (wynik.has(nazwa) ? wynik.get(nazwa) : true) && jest(stany[i], miasto));
      });
      return [...wynik].map(([nazwa, dostepny]) => ({ nazwa, dostepny }));
    };
    return czyMa;
  };

  /* Stawka techniczna dla aplikacji Google: w kasie chowa ja regula SMART
     Checkout Rules „nazwa zawiera Standard”, wiec okno pomija ja ta sama
     regula - inaczej obiecaloby dowoz za 99 EUR tam, gdzie kasa go nie pokaze. */
  const TECHNICZNA = /standard/i;

  /* Wzorce zapisu kodu pocztowego. Ta lista opisuje FORMATY, nie kraje -
     kraje siedza w blokach sekcji, wiec dolozenie kolejnego jest wpisem
     w panelu, a nie zmiana w tym pliku. */
  const WZORCE = {
    nl: /^\d{4}[A-Z]{2}$|^\d{4}$/,
    cyfry4: /^\d{4}$/,
    cyfry5: /^\d{5}$/,
    pl: /^\d{2}-?\d{3}$/,
    dowolny: /^.{3,}$/,
  };

  /* Kod sprowadzony do liczby: same cyfry sklejone w jedna (dzis sluzy juz
     tylko do sprawdzenia formatu kraju). 1012 AB -> 1012, 43-300 -> 43300.
     Zapis niezgodny z formatem kraju oddaje null - wtedy okno prosi
     o poprawke, zamiast zgadywac odpowiedz. */
  const numerKodu = (format, wpis) => {
    let kod = String(wpis || '').toUpperCase().replace(/\s+/g, '');
    const wzorzec = WZORCE[format] || WZORCE.dowolny;
    // Myslnik w miejscu spacji w kodzie holenderskim („5611-AB”) to zwykly
    // zapis, nie blad. Tylko tam: w innych formatach zdjety myslnik robil
    // z polskiego 00-950 niemieckie 00950.
    if (format === 'nl' && !wzorzec.test(kod) && wzorzec.test(kod.replace(/-/g, ''))) kod = kod.replace(/-/g, '');
    if (!wzorzec.test(kod)) return null;
    const cyfry = kod.replace(/\D/g, '');
    return cyfry === '' ? 0 : Number(cyfry);
  };

  class DeliveryCheck extends HTMLElement {
    connectedCallback() {
      if (this.dataset.gotowy === '1') return;
      this.dataset.gotowy = '1';

      this.poZamknieciu = null;
      this.wymagaRezerwacji = false;
      /* Czy okno stoi teraz w gniezdzie kroku 2 szuflady koszyka. W tym
         trybie nie jest oknem: nie zaciemnia tla, nie blokuje przewijania
         i nie daje sie zamknac - krokami steruje szuflada. */
      this.trybWKoszyku = false;
      this.trybRezerwacji = null;
      this.naglowekDomyslny = this.tytul?.textContent || '';
      this.podpisDomyslny = this.podpis?.textContent || '';
      /* Czy klient dostal juz werdykt. Zamkniecie BEZ odpowiedzi znaczy
         „rezygnuje" - wtedy akcja, ktora czekala za oknem (dodanie do
         koszyka), nie dochodzi do skutku. */
      this.odpowiedziano = false;

      /* Wszystkie zdarzenia wiszą na SAMYM oknie, a pola wyszukujemy przy
         każdym użyciu. Podmiana wnętrza sekcji (edytor motywu, gorące
         przeładowanie podglądu) odpina listener przyklejony do formularza,
         a wtedy „Sprawdź" przestaje cokolwiek robić - objaw jest cichy, bo
         formularz po prostu nic nie zgłasza. */
      this.addEventListener('click', (zdarzenie) => {
        const startRezerwacji = zdarzenie.target.closest('[data-booking-start]');
        if (startRezerwacji) {
          zdarzenie.preventDefault();
          this.rozpocznijRezerwacje('pickup', startRezerwacji.dataset.bookingWarehouse, startRezerwacji);
          return;
        }
        const wyborOdbioru = zdarzenie.target.closest('[data-pickup-choose]');
        if (wyborOdbioru) {
          zdarzenie.preventDefault();
          if (!wyborOdbioru.disabled) this.wybierzOdbior(wyborOdbioru);
          return;
        }
        if (!zdarzenie.target.closest('[data-delivery-close]')) return;
        zdarzenie.preventDefault();
        this.zamknij();
      });

      this.addEventListener('booking:back', () => {
        if (this.trybRezerwacji === 'showroom') {
          this.zamknij();
          return;
        }
        this.classList.remove('dcheck--booking');
        this.booking?.reset();
        this.zaznaczMagazyn(null);
        this.przywrocNaglowek();
      });

      this.addEventListener('submit', (zdarzenie) => {
        if (!zdarzenie.target.closest('[data-delivery-form]')) return;
        zdarzenie.preventDefault();
        this.sprawdz();
      });

      // Poprawka w polu zdejmuje komunikat o zlym formacie od razu - klient
      // nie musi czekac na kolejne klikniecie „Sprawdz", zeby zobaczyc, ze
      // zarzut przestal byc aktualny.
      this.addEventListener('input', (zdarzenie) => {
        if (!zdarzenie.target.closest('[data-delivery-zip]')) return;
        this.schowajBlad();
      });

      document.addEventListener('keydown', (zdarzenie) => {
        if (this.trybWKoszyku) return;
        if (zdarzenie.key === 'Escape' && !this.hidden) this.zamknij();
      });

      // Wejscie na zadanie: kalkulator wysylki w szufladzie koszyka. Szuflada
      // przebudowuje swoje wnetrze po kazdej zmianie koszyka, wiec sluchamy na
      // dokumencie, a nie na samym przycisku.
      document.addEventListener('click', (zdarzenie) => {
        const wejscie = zdarzenie.target.closest('[data-delivery-check-open]');
        if (!wejscie) return;
        zdarzenie.preventDefault();
        /* Ten sam przycisk stoi w kalkulatorze wysylki w szufladzie koszyka -
           tam nie otwieramy okna, tylko przechodzimy na krok 2. Robi to sama
           szuflada, wiec tutaj oddajemy jej pole. */
        if (wejscie.closest('cart-drawer')) return;
        this.otworz(null);
      });

      this.podepnijPrzeciaganieUchwytu();

      window.dizzDostawa = {
        sprawdzone: () => juzBylo(),
        otworz: (dalej) => this.otworz(dalej),
        /* Oddaje false, gdy kalendarza nie ma (rezerwacje wylaczone w sekcji,
           np. na motywie glownym przed publikacja) - wtedy wolajacy zostawia
           zwykly odnosnik zamiast otwierac puste okno dostawy. */
        umow: (magazyn) => {
          if (!this.booking || !magazyn) return false;
          this.otworz(null);
          requestAnimationFrame(() => this.rozpocznijRezerwacje('showroom', magazyn));
          return true;
        },
        /* Wejscie dla szuflady koszyka: okno wchodzi w jej gniazdo kroku 2
           i wraca na swoje miejsce w layoucie, gdy krok sie konczy. */
        wKoszyku: (gniazdo) => this.wKoszyku(gniazdo),
        zKoszyka: () => this.zKoszyka(),
        /* Szuflada pyta o to samo przy UMOWIONYM juz odbiorze: koszyk mogl
           urosnac po rezerwacji o wzor, ktorego w tym magazynie nie ma. */
        magazynyZKoszykiem,
        zresetuj: () => this.zresetuj(),
      };
    }

    get panel() { return this.querySelector('.dcheck__panel'); }
    get tytul() { return this.querySelector('.dcheck__title'); }
    get podpis() { return this.querySelector('.dcheck__lead'); }
    get pole() { return this.querySelector('[data-delivery-field]'); }
    get poleKodu() { return this.querySelector('[data-delivery-zip]'); }
    get blad() { return this.querySelector('[data-delivery-error]'); }
    get wynik() { return this.querySelector('[data-delivery-result]'); }
    get wynikTak() { return this.querySelector('[data-delivery-ok]'); }
    get wynikNie() { return this.querySelector('[data-delivery-no]'); }
    get stawki() { return this.querySelector('[data-delivery-rates]'); }
    get przycisk() { return this.querySelector('[data-delivery-submit]'); }
    get napisPrzycisku() { return this.querySelector('[data-delivery-submit-label]'); }
    get booking() { return this.querySelector('[data-booking-picker]'); }
    get copy() { return this.czytajCopy(); }

    czytajCopy() {
      const zrodlo = this.querySelector('[data-delivery-copy]');
      if (!zrodlo) return {};
      try {
        return JSON.parse(zrodlo.textContent);
      } catch (e) {
        return {};
      }
    }

    /* ---------- sprawdzenie ---------- */

    /* Jedno sprawdzenie naraz, z kolowrotkiem na przycisku od klikniecia do
       wyniku. Wynik (werdykt RAZEM z cena) pokazujemy dopiero w komplecie -
       wczesniej zielona ramka wchodzila sama, a wiersz z cena dochodzil po
       chwili i spychal reszte okna w dol (zgloszenie 20 pazdziernika 2026). */
    async sprawdz() {
      if (this.sprawdzanie) return;
      this.sprawdzanie = true;
      /* Wylaczony przycisk gubi fokus (laduje na <body>) - po sprawdzeniu
         oddajemy go tam, gdzie klient byl (audyt na slepo 27.10.2026). */
      const fokusPrzed = document.activeElement;
      this.wlaczLadowanie();
      // Poprzedni werdykt znika na czas sprawdzania - inaczej stary wynik
      // wisialby obok kolowrotka, a nowy wskakiwalby w jego miejsce.
      if (this.wynik) this.wynik.hidden = true;
      try {
        await this.sprawdzKod();
      } finally {
        this.sprawdzanie = false;
        if (!this.zegarPotwierdzenia) this.wylaczPotwierdzenie();
        const teraz = document.activeElement;
        if (fokusPrzed && fokusPrzed.isConnected && (!teraz || teraz === document.body) && !fokusPrzed.disabled) {
          fokusPrzed.focus({ preventScroll: true });
        }
      }
    }

    wlaczLadowanie() {
      window.clearTimeout(this.zegarPotwierdzenia);
      this.zegarPotwierdzenia = null;
      if (this.przycisk) {
        this.przycisk.classList.add('dcheck__submit--laduje');
        this.przycisk.disabled = true;
      }
    }

    async sprawdzKod() {
      const copy = this.copy;
      const kraj = copy.kraj || '';
      let wpis = this.poleKodu ? this.poleKodu.value.trim() : '';
      const kraje = copy.kraje || {};

      /* Kod z miastem („2000 Antwerpen”, „5611 AB Eindhoven”, „44309
         Dortmund”) nie pasowal do zadnego formatu, a mial cztery cyfry, wiec
         dostawal „nie dowozimy” (audyt 27.10.2026). Bierzemy sam kod z poczatku
         (4-5 cyfr, w NL z dwiema literami), miasto odpada - takze w polu. */
      const zMiastem = wpis.match(/^(\d{4,5}(?:\s?[A-Za-z]{2}(?![A-Za-z]))?)[\s,]+(\D*\p{L}{3}\D*)$/u);
      if (zMiastem) {
        wpis = zMiastem[1];
        if (this.poleKodu) this.poleKodu.value = wpis;
      }

      /* Kraj bierzemy z ZAPISU KODU, nie z przelacznika w naglowku: klient
         z Holandii, ktoremu sklep ustawil Niemcy, wpisuje 5611 AB i ma dostac
         odpowiedz dla Holandii (zgloszenie 20 pazdziernika 2026). Przelacznik
         rozstrzyga tylko kod pasujacy do kilku krajow (cztery cyfry = NL albo
         BE) - wtedy sprawdzamy sam kraj z przelacznika. Gdy przelacznik nie
         jest wsrod pasujacych, sprawdzamy je po kolei blokow sekcji i pierwszy
         „tak” wygrywa. */
      /* Znak, ktorego w kodzie pocztowym byc nie moze (dwukropek, kropka,
         przecinek...), to literowka, a nie kod z innego kraju - od razu prosba
         o poprawke, zanim regula „cztery cyfry = obcy kod” powie „nie dowozimy”
         (zgloszenie 20 pazdziernika 2026: „5611 AB:”). */
      /* Przyklad w komunikacie z kraju, na ktorego kod WYGLADA wpis (po
         zdjeciu zbednych znakow), a nie z przelacznika: „5611 AB:” przy
         Niemczech dostawal „Na przyklad 44145”. */
      const oczyszczony = wpis.replace(/[^0-9A-Za-z\s-]/g, '');
      const podobny = Object.keys(kraje).find((k) => numerKodu(kraje[k].format, oczyszczony) !== null);
      const przyklad = (kraje[podobny] || kraje[kraj] || {}).przyklad;
      if (/[^0-9A-Za-z\s-]/.test(wpis)) return this.pokazBlad(przyklad);
      const pasujace = Object.keys(kraje).filter((k) => numerKodu(kraje[k].format, wpis) !== null);
      if (!pasujace.length) {
        /* Zapis, ktory nie pasuje do zadnego kraju dostawy, ale WYGLADA jak
           prawdziwy kod pocztowy (cztery cyfry albo wiecej), jest kodem z kraju,
           do ktorego nie wozimy - wtedy odpowiedzia jest „nie dowozimy", a nie
           zarzut literowki. O poprawke prosimy tylko przy wpisie, ktory kodem
           byc nie moze (za krotki, same litery). */
        const cyfry = wpis.replace(/\D/g, '');
        if (cyfry.length >= 4) return this.pokazNie();
        return this.pokazBlad(przyklad);
      }
      /* Kraj z przelacznika idzie pierwszy. Jego odpowiedz „nie” jest
         ostateczna; „kod nieznany” (taki kod w tym kraju nie istnieje, np. 8000
         w Holandii) przechodzi do nastepnego pasujacego kraju (8000 = Brugia). */
      const kolejnosc = pasujace.includes(kraj) ? [kraj, ...pasujace.filter((k) => k !== kraj)] : pasujace;
      const zTowarem = await this.koszykZTowarem();

      let krajDostawy = null;
      let krajNie = null;
      let stawki = [];
      let niepewne = false;
      const bylo = { nie: false, brak: false };
      this.cenaUslugi = null;
      for (const k of kolejnosc) {
        /* Koszyk z towarem: decyduja stawki sklepu dla tego adresu - te same,
           ktore pokaze kasa. Sklep nie odpowie (siec, blad) = pytamy usluge. */
        let werdykt = null;
        if (zTowarem) {
          const kasa = await this.stawkiKasy(wpis, k);
          if (kasa.stan === 'ok' && kasa.stawki.length) {
            werdykt = 'tak';
            stawki = kasa.stawki;
          } else if (kasa.stan === 'ok') {
            /* Pusta lista ze sklepu nie jest pewna: po wpisaniu adresu w kasie
               Shopify trzyma go przy koszyku (takze po wyczyszczeniu) i stawki
               liczy dla TAMTEGO adresu - audyt 26 pazdziernika 2026: Groningen
               w kasie, potem 5611 AB w oknie = puste stawki i falszywe „nie”.
               Usluga liczy z samego wpisanego kodu; jej „tak” wygrywa, a wlasciwa
               stawke pokaze kasa po wpisaniu tego adresu. */
            const zUslugi = await this.werdyktUslugi(k, wpis);
            werdykt = zUslugi === 'tak' ? 'tak' : 'nie';
          } else if (kasa.stan === 'sklejone') {
            /* Kwota sklejona przy „tak” jest wlasciwa (przewoznik oddaje 49,
               Shopify bierze najtansza), przy „nie” to stawka techniczna. */
            werdykt = await this.werdyktUslugi(k, wpis);
            if (werdykt === 'tak') stawki = kasa.stawki;
          } else if (kasa.stan === 'nieznany') {
            werdykt = 'brak';
          }
        }
        if (werdykt === null) werdykt = await this.werdyktUslugi(k, wpis);
        if (werdykt === 'brak') {
          bylo.brak = true;
          continue;
        }
        if (werdykt === 'nie') {
          bylo.nie = true;
          if (!krajNie) krajNie = k;
          if (k === kraj) break;
          continue;
        }
        krajDostawy = k;
        /* Ani sklep, ani usluga nie odpowiedzieli: „Dowozimy” byloby
           zgadywaniem - mowimy wprost, ze pewna odpowiedz da kasa (AUD-03). */
        niepewne = werdykt === null;
        break;
      }
      /* Odbior osobisty kasa Shopify daje tylko w KRAJU ADRESU, wiec po werdykcie
         kafle magazynow ida za krajem wpisanego kodu, nie za przelacznikiem
         sklepu - kod z Belgii przy rynku NL dostawal Valkenswaard, a kasa przy
         belgijskim adresie odbioru nie dawala (audyt na slepo 27.10.2026). */
      const krajKodu = krajDostawy || krajNie || null;
      if (krajKodu !== this.krajKodu) {
        this.krajKodu = krajKodu;
        await this.oznaczMagazyny();
      }
      if (!krajDostawy) {
        if (!bylo.nie && bylo.brak) return this.pokazBlad((kraje[pasujace[0]] || {}).przyklad);
        return this.pokazNie();
      }
      /* Kraj i kod ida z werdyktem do szuflady, ktora wpisuje je w adres kasy -
         bez tego kasa prosila o adres od nowa i do tego czasu pisala „wpisz
         adres, zeby zobaczyc wysylke”, co klient czytal jak „nie ma dostawy”. */
      this.adresDostawy = { kraj: krajDostawy, kod: wpis };
      if (niepewne) return this.pokazNiepewne();
      if (!stawki.length && this.cenaUslugi) stawki = [{ name: this.copy.stawkaDostawy || '', price: this.cenaUslugi }];
      this.pokazTak();
      this.wypiszStawki(stawki);
      /* Okno stoi PRZED dodaniem do koszyka, wiec teraz przycisk mowi wprost,
         co sie dzieje, i po chwili oddaje pole szufladzie koszyka. */
      if (this.poZamknieciu) {
        this.wlaczPotwierdzenie();
        this.zegarPotwierdzenia = window.setTimeout(() => this.zamknij(), CZAS_POTWIERDZENIA);
      }
    }

    /* Czy w koszyku jest cos do wyslania - pusty koszyk (strona Kontakt) nie
       ma czego wycenic, wtedy werdykt daje sama usluga dostawy. */
    async koszykZTowarem() {
      try {
        const koszyk = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        return (koszyk.items || []).some((p) => p.requires_shipping !== false);
      } catch (e) {
        return false;
      }
    }

    /* 'tak' / 'nie' / 'brak' (kod nieznany w tym kraju) z uslugi dostawy,
       null = brak odpowiedzi (wtedy decyduje stary werdykt po kraju). Koszyk idzie razem z adresem, bo usluga szuka
       magazynu z CALYM koszykiem; pusty koszyk (strona Kontakt) = sama odleglosc. */
    async werdyktUslugi(kraj, kod) {
      const usluga = (this.copy.usluga || '').replace(/\/$/, '');
      if (!usluga) return null;
      const przerwij = new AbortController();
      const zegar = window.setTimeout(() => przerwij.abort(), CZAS_USLUGI);
      try {
        let warianty = '';
        try {
          const koszyk = await (await fetch('/cart.js', { headers: { Accept: 'application/json' }, signal: przerwij.signal })).json();
          warianty = (koszyk.items || [])
            .filter((p) => p.requires_shipping !== false)
            .map((p) => `${p.variant_id}:${p.quantity}`)
            .join(',');
        } catch (e) {
          if (przerwij.signal.aborted) return null;
        }
        const parametry = new URLSearchParams({ kraj, kod });
        if (warianty) parametry.set('warianty', warianty);
        const odpowiedz = await fetch(`${usluga}/sprawdz?${parametry}`, { signal: przerwij.signal });
        if (!odpowiedz.ok) return null;
        const dane = await odpowiedz.json();
        /* Kwota z uslugi - pokazujemy ja, gdy sklep nie oddal stawek (pusta lista
           albo sklejona), zeby „dowozimy” nie stalo bez ceny (audyt 27.10.2026). */
        this.cenaUslugi = dane.dowozimy === true && Number(dane.cena) > 0 ? Number(dane.cena) : null;
        if (dane.dowozimy === true) return 'tak';
        if (dane.dowozimy !== false) return null;
        return dane.powod === 'brak_adresu' ? 'brak' : 'nie';
      } catch (e) {
        return null;
      } finally {
        window.clearTimeout(zegar);
      }
    }

    /* Stan „Dodaje": przycisk z kolowrotkiem, pole i przycisk zablokowane,
       zeby drugie klikniecie nie wystartowalo drugiego odliczania. */
    wlaczPotwierdzenie() {
      const przycisk = this.przycisk;
      const napis = this.napisPrzycisku;
      if (przycisk) {
        przycisk.classList.add('dcheck__submit--laduje');
        przycisk.disabled = true;
      }
      if (napis) napis.textContent = this.copy.dodaje || napis.textContent;
      if (this.poleKodu) this.poleKodu.readOnly = true;
    }

    wylaczPotwierdzenie() {
      window.clearTimeout(this.zegarPotwierdzenia);
      const przycisk = this.przycisk;
      const napis = this.napisPrzycisku;
      if (przycisk) {
        przycisk.classList.remove('dcheck__submit--laduje');
        przycisk.disabled = false;
      }
      if (napis) napis.textContent = this.copy.sprawdz || napis.textContent;
      if (this.poleKodu) this.poleKodu.readOnly = false;
    }

    /* Przyklad zapisu dokladamy z bloku kraju, wiec komunikat sam podpowiada
       format tego kraju, w ktorym klient akurat kupuje. */
    pokazBlad(przyklad) {
      if (this.blad) {
        this.blad.textContent = [this.copy.blad, przyklad].filter(Boolean).join(' ');
        this.blad.hidden = false;
      }
      if (this.pole) this.pole.classList.add('dcheck__field--blad');
      if (this.wynik) this.wynik.hidden = true;
      if (this.poleKodu) this.poleKodu.focus();
    }

    schowajBlad() {
      if (this.blad) this.blad.hidden = true;
      if (this.pole) this.pole.classList.remove('dcheck__field--blad');
    }

    /* Werdykt oglaszamy na zewnatrz - w kroku 2 szuflada odblokowuje po nim
       przejscie do kasy. Zdarzenie babelkuje, wiec szuflada slucha na sobie. */
    zglosWerdykt(dowozimy) {
      if (this.trybWKoszyku) zapamietaj();
      /* Kod pocztowy przezywa przejscie na inna strone sklepu: w kroku 2
         sprawdzamy go od nowa sami (stawki zaleza od koszyka), zamiast kazac
         klientowi wpisywac go drugi raz (audyt na slepo 26.10.2026). */
      try {
        if (this.poleKodu && this.poleKodu.value.trim()) sessionStorage.setItem(KLUCZ_KOD, this.poleKodu.value.trim());
      } catch (e) { /* tryb prywatny przegladarki */ }
      /* `wymagaOdbioru` mowi szufladzie, ze sam werdykt nie wystarczy: nie
         dowozimy, ale magazyny umieja przyjac rezerwacje, wiec klient ma
         jeszcze cos do zrobienia, zanim pojdzie do kasy. */
      /* „Nie dowozimy” w koszyku nie otwiera juz kasy samo: kasa i tak nie
         sprzeda dostawy pod ten adres, wiec klient musi wybrac magazyn (klik
         w kafel albo termin w kalendarzu). Gdy odbioru nie ma (kraj bez
         magazynu, zaden magazyn bez kompletu), kasa zostaje zamknieta, a okno
         mowi, co dalej - wczesniej „Afrekenen” prowadzilo do kasy z napisem
         „wysylka niedostepna” (audyt na slepo 27.10.2026). */
      this.dispatchEvent(new CustomEvent('dostawa:werdykt', {
        bubbles: true,
        detail: {
          dowozimy,
          wymagaOdbioru: !dowozimy && (this.wymagaRezerwacji || this.trybWKoszyku),
          adres: dowozimy ? this.adresDostawy || null : null,
        },
      }));
    }

    pokazTak() {
      this.odpowiedziano = true;
      this.ustawNaglowekTak(false);
      this.schowajBlad();
      if (this.stawki) this.stawki.textContent = '';
      if (this.wynikNie) this.wynikNie.hidden = true;
      if (this.wynikTak) this.wynikTak.hidden = false;
      if (this.wynik) this.wynik.hidden = false;
      this.werdyktOkna = 'tak';
      this.uzgodnijOdbior();
      this.zglosWerdykt(true);
    }

    pokazNiepewne() {
      this.pokazTak();
      this.ustawNaglowekTak(true);
    }

    /* Ta sama ramka co „Dowozimy", ale bez znacznika i z tekstem „nie udalo sie potwierdzic". */
    ustawNaglowekTak(niepewne) {
      const ramka = this.wynikTak;
      if (!ramka) return;
      const znak = ramka.querySelector('.dcheck-ok__mark');
      const tekst = ramka.querySelector('.dcheck-ok__head > span:last-child');
      if (znak) znak.hidden = niepewne;
      const napis = niepewne ? this.copy.niepewne : this.copy.tak;
      if (tekst && napis) tekst.textContent = napis;
    }

    pokazNie() {
      this.adresDostawy = null;
      this.wymagaRezerwacji = Boolean(this.booking && [...this.querySelectorAll('[data-booking-start]')].some((przycisk) => !(przycisk.closest('.dcheck-no__point') || {}).hidden));
      this.odpowiedziano = !this.wymagaRezerwacji;
      this.schowajBlad();
      if (this.stawki) this.stawki.textContent = '';
      if (this.wynikTak) this.wynikTak.hidden = true;
      if (this.wynikNie) this.wynikNie.hidden = false;
      if (this.wynik) this.wynik.hidden = false;
      this.werdyktOkna = 'nie';
      this.uzgodnijOdbior();
      this.zglosWerdykt(false);
    }


    rozpocznijRezerwacje(rodzaj, magazyn, kafel) {
      if (!this.booking || !magazyn) return;
      if (this.querySelector('[data-pickup-choose].dcheck-point--wybrany')) this.wybierzOdbior(null);
      this.trybRezerwacji = rodzaj;
      this.zaznaczMagazyn(kafel);
      this.ustawNaglowekRezerwacji(this.nazwaMagazynu);
      this.classList.add('dcheck--booking');
      this.booking.start({
        rodzaj,
        magazyn,
        poRezerwacji: rodzaj === 'pickup'
          ? () => {
              this.odpowiedziano = true;
              this.wymagaRezerwacji = false;
              /* W kroku 2 szuflady to jest moment, w ktorym kasa sie otwiera -
                 termin odbioru jest juz zapisany w atrybutach koszyka. */
              this.dispatchEvent(new CustomEvent('dostawa:odbior', {
                bubbles: true,
                detail: { magazyn },
              }));
              window.setTimeout(() => this.zamknij(), CZAS_POTWIERDZENIA);
            }
          /* Wizyta umawiana ze strony Kontakt: klient nie ma tu juz nic do
             zrobienia, wiec okno znika samo po przeczytaniu potwierdzenia. */
          : () => {
              this.odpowiedziano = true;
              this.wymagaRezerwacji = false;
              this.zegarPotwierdzenia = window.setTimeout(
                () => this.zamknij(),
                CZAS_POTWIERDZENIA_WIZYTY,
              );
            },
      });
    }

    /* Bez kalendarza rezerwacji kafel magazynu jest wyborem odbioru: klient,
       ktory i tak odbierze sam, nie musi podawac kodu pocztowego, zeby dojsc
       do kasy (tam wybiera odbior w tym magazynie). Szuflada slucha
       `dostawa:wybor-odbioru`; magazyn null = wybor zdjety (np. magazyn
       stracil komplet po zmianie koszyka). */
    wybierzOdbior(kafel) {
      this.zaznaczMagazyn(kafel);
      this.querySelectorAll('[data-pickup-choose]').forEach((przycisk) => {
        if (przycisk !== kafel) przycisk.setAttribute('aria-pressed', 'false');
        const dopisek = przycisk.querySelector('[data-pickup-hint]');
        if (dopisek) dopisek.hidden = przycisk !== kafel;
      });
      this.dispatchEvent(new CustomEvent('dostawa:wybor-odbioru', {
        bubbles: true,
        detail: { magazyn: kafel ? this.nazwaMagazynu : null },
      }));
    }

    /* Z trzech kafli zostaje na ekranie TEN wybrany - inaczej nad kalendarzem
       stala nadal cala lista i nie bylo widac, ktory magazyn sie wybralo. */
    zaznaczMagazyn(kafel) {
      this.nazwaMagazynu = '';
      this.querySelectorAll('.dcheck-point--wybrany').forEach((stary) => {
        stary.classList.remove('dcheck-point--wybrany');
        stary.removeAttribute('aria-pressed');
        stary.closest('.dcheck-no__point')?.classList.remove('dcheck-no__point--wybrany');
      });
      if (!kafel) return;
      kafel.classList.add('dcheck-point--wybrany');
      kafel.setAttribute('aria-pressed', 'true');
      kafel.closest('.dcheck-no__point')?.classList.add('dcheck-no__point--wybrany');
      const nazwa = kafel.querySelector('.dcheck-point__name');
      this.nazwaMagazynu = nazwa ? nazwa.textContent.trim() : '';
    }

    ustawNaglowekRezerwacji(nazwa) {
      if (this.tytul) this.tytul.textContent = this.copy.booking?.title || this.naglowekDomyslny;
      if (!this.podpis) return;
      /* Podpis pod tytulem mowi, o ktory magazyn chodzi. Bez nazwy (spotkanie
         umawiane ze strony Kontakt) chowamy go - zdanie o dowozie nic tam nie
         wnosi, bo klient wlasnie wybiera termin wizyty. */
      this.podpis.textContent = nazwa || '';
      this.podpis.hidden = !nazwa;
    }

    przywrocNaglowek() {
      if (this.tytul) this.tytul.textContent = this.naglowekDomyslny;
      if (this.podpis) {
        this.podpis.textContent = this.podpisDomyslny;
        this.podpis.hidden = this.podpisDomyslny === '';
      }
    }

    /* Stawki sklepu dla adresu - te same, ktore policzy kasa (przewoznik
       z usluga dostawy, stawka probek), bez stawki technicznej.
       stan: 'ok' (lista, pusta = nie dowozimy), 'nieznany' (Shopify nie uznaje
       kodu w tym kraju - 422), 'blad' (brak odpowiedzi - werdykt da usluga). */
    async stawkiKasy(kod, kraj) {
      const parametry = new URLSearchParams({
        'shipping_address[zip]': kod,
        'shipping_address[country]': kraj,
      });
      const przerwij = new AbortController();
      const zegar = window.setTimeout(() => przerwij.abort(), CZAS_USLUGI);
      try {
        /* Pod prefiksem jezyka strony (/pl/, /de/...): bez niego Shopify pyta
           usluge dostawy w jezyku glownym sklepu i nazwa stawki wychodzi po
           niderlandzku („Bezorging”) na kazdej wersji jezykowej. */
        const korzen = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const odpowiedz = await fetch(`${korzen}cart/shipping_rates.json?${parametry}`, {
          headers: { Accept: 'application/json' },
          signal: przerwij.signal,
        });
        if (odpowiedz.status === 422) return { stan: 'nieznany', stawki: [] };
        if (!odpowiedz.ok) return { stan: 'blad', stawki: [] };
        const dane = await odpowiedz.json();
        const stawki = (dane.shipping_rates || []).filter((s) => !TECHNICZNA.test(`${s.name || ''} ${s.presentment_name || ''}`));
        /* Koszyk z plyta I probka: Shopify skleja stawki obu profili w jedna
           o ogolnej nazwie („Verzending”, zrodlo „shopify”), wiec techniczna
           „Standard” 99 EUR przechodzi przez filtr nazwy - poza zasiegiem
           wychodzilo „dowozimy, 99 EUR”, a kasa odmawiala (audyt 27.10.2026,
           Flensburg). Przy sklejonej stawce werdykt daje usluga dostawy. */
        const znane = this.copy.nazwyStawek || {};
        const sklejone = stawki.some((s) => String(s.source || '').toLowerCase() === 'shopify' && !(s.name in znane));
        return { stan: sklejone ? 'sklejone' : 'ok', stawki };
      } catch (e) {
        return { stan: 'blad', stawki: [] };
      } finally {
        window.clearTimeout(zegar);
      }
    }

    wypiszStawki(lista) {
      if (!this.stawki) return;
      lista.forEach((stawka) => {
        const wiersz = document.createElement('li');
        wiersz.className = 'dcheck-ok__row';

        const nazwa = document.createElement('span');
        nazwa.className = 'dcheck-ok__name';
        /* Stale stawki (probki) sklep oddaje zawsze po polsku - nazwe w jezyku strony bierzemy z tlumaczen motywu. */
        nazwa.textContent = (this.copy.nazwyStawek || {})[stawka.name] || stawka.name;

        const cena = document.createElement('span');
        cena.className = 'dcheck-ok__price';
        cena.textContent = this.kwota(stawka.price);

        wiersz.append(nazwa, cena);
        this.stawki.appendChild(wiersz);
      });
    }

    kwota(wartosc) {
      const liczba = Number(wartosc);
      if (Number.isNaN(liczba)) return String(wartosc);
      /* Format kwoty sklepu (data-money-format), jak w cenach na reszcie
         strony: Intl w angielskim dawal "€49.00" obok "€69,00" przy panelach
         (audyt na slepo 26.10.2026). */
      const format = this.dataset.moneyFormat;
      if (format) {
        const [calosc, ulamek] = liczba.toFixed(2).split('.');
        const zKropka = calosc.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        const zPrzecinkiem = calosc.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        const zSpacja = calosc.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        const warianty = {
          amount: `${zPrzecinkiem}.${ulamek}`,
          amount_no_decimals: zPrzecinkiem,
          amount_with_comma_separator: `${zKropka},${ulamek}`,
          amount_no_decimals_with_comma_separator: zKropka,
          amount_with_space_separator: `${zSpacja},${ulamek}`,
          amount_no_decimals_with_space_separator: zSpacja,
        };
        const wynik = format.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, klucz) => warianty[klucz] ?? '');
        if (/\d/.test(wynik)) return wynik.replace(/<[^>]*>/g, '');
      }
      try {
        return new Intl.NumberFormat(this.dataset.locale || undefined, {
          style: 'currency',
          currency: this.dataset.currency || 'EUR',
        }).format(liczba);
      } catch (e) {
        return `${liczba.toFixed(2)} ${this.dataset.currency || ''}`.trim();
      }
    }

    /* ---------- krok 2 szuflady koszyka ---------- */

    /* Okno wchodzi do gniazda kroku 2 CALYM wezlem - drugiej kopii markupu
       w motywie nie ma. Miejsce w layoucie zapamietujemy, zeby strona Kontakt
       dostala je z powrotem takie samo. */
    wKoszyku(gniazdo) {
      if (!gniazdo) return;
      if (!this.dom) this.dom = { rodzic: this.parentNode, przed: this.nextSibling };
      this.trybWKoszyku = true;
      this.classList.remove('dcheck--open');
      this.odblokujPrzewijanie();
      window.clearTimeout(this.zegarPotwierdzenia);
      this.poZamknieciu = null;
      if (this.parentNode !== gniazdo) gniazdo.appendChild(this);
      /* W szufladzie okno nie jest dialogiem - dialogiem jest sama szuflada,
         a dwa naraz mylilyby czytnik ekranu. */
      const panel = this.panel;
      if (panel) {
        panel.removeAttribute('aria-modal');
        panel.setAttribute('role', 'group');
        panel.removeAttribute('tabindex');
      }
      this.hidden = false;
      this.oznaczMagazyny();
      let zapisanyKod = '';
      try { zapisanyKod = sessionStorage.getItem(KLUCZ_KOD) || ''; } catch (e) { /* tryb prywatny */ }
      if (zapisanyKod && this.poleKodu && !this.poleKodu.value.trim() && !this.odpowiedziano && !this.sprawdzanie) {
        this.poleKodu.value = zapisanyKod;
        this.sprawdz();
      }
    }

    /* Magazyn bez calego koszyka zostaje na liscie, ale nie da sie go wybrac
       do odbioru - inaczej klient umawial termin, a kasa i tak nie pokazywala
       mu odbioru w tym miejscu. Poza szuflada (wizyta ze strony Kontakt)
       koszyk nie ma znaczenia, wiec kafle wracaja do stanu z Liquida. */
    async oznaczMagazyny() {
      /* Kasa Shopify pokazuje odbior osobisty TYLKO z magazynu w kraju
         kupujacego (zachowanie Shopify, bez wylacznika) - klient z NL nie
         dostanie w kasie Dortmundu. W szufladzie zostaja wiec magazyny z kraju
         wybranego w sklepie; okno ze strony Kontakt (wizyta) pokazuje wszystkie
         (audyt na slepo 26.10.2026). */
      let krajSklepu = (this.krajKodu || (window.Shopify && window.Shopify.country) || '').toUpperCase();
      /* Kraj bez zadnego magazynu (np. PL na podgladzie) nie chowa niczego -
         inaczej klient zostawal bez ani jednego miejsca odbioru. */
      const krajeMagazynow = new Set([...this.querySelectorAll('[data-point-city][data-point-country]')].map((kafel) => kafel.dataset.pointCountry));
      /* Kraj dostawy bez magazynu z odbiorem (dzis Belgia - Schelle ma odbior
         wylaczony) nie dostaje w kasie ZADNEGO punktu odbioru, wiec w koszyku
         blok odbioru znika caly. Wczesniej obiecywal Valkenswaard i Dortmund,
         a kasa pisala „brak punktow w Belgii” (audyt na slepo 27.10.2026). */
      const krajDostawy = Object.prototype.hasOwnProperty.call((this.copy && this.copy.kraje) || {}, krajSklepu);
      const bezOdbioru = Boolean(this.trybWKoszyku && krajDostawy && !krajeMagazynow.has(krajSklepu));
      if (!krajeMagazynow.has(krajSklepu) && !bezOdbioru) krajSklepu = '';
      this.querySelectorAll('[data-point-country]').forEach((kafel) => {
        kafel.hidden = Boolean(this.trybWKoszyku && krajSklepu && kafel.dataset.pointCountry !== krajSklepu);
      });
      const blokOdbioru = this.querySelector('[data-delivery-pickup]');
      if (blokOdbioru) blokOdbioru.hidden = bezOdbioru;
      /* Zdanie "Odbior gratis w magazynie X lub Y" sklejane z nazw, ktore
         zostaly widoczne - inaczej obiecywalo Dortmund klientowi z NL. */
      this.querySelectorAll('[data-pickup-names]').forEach((zdanie) => {
        const nazwy = [...zdanie.querySelectorAll('.dcheck-pickup__name')].filter((nazwa) => !nazwa.hidden);
        nazwy.forEach((nazwa, i) => {
          const lacznik = nazwa.querySelector('[data-pickup-sep]');
          if (!lacznik) return;
          if (i === 0) lacznik.textContent = '';
          else if (i === nazwy.length - 1) lacznik.textContent = ` ${zdanie.dataset.or || ''} `;
          else lacznik.textContent = ', ';
        });
      });
      const kafle = [...this.querySelectorAll('[data-point-city]')].filter((kafel) => !kafel.hidden);
      const brakKompletu = this.querySelector('[data-pickup-none]');
      const ustaw = (czyMa) => {
        let ktorykolwiek = false;
        kafle.forEach((kafel) => {
          const ma = czyMa ? czyMa(kafel.dataset.pointCity) : true;
          if (ma) ktorykolwiek = true;
          const przycisk = kafel.querySelector('[data-booking-start], [data-pickup-choose]');
          if (przycisk) przycisk.disabled = !ma;
          if (!ma && przycisk && przycisk.matches('.dcheck-point--wybrany[data-pickup-choose]')) this.wybierzOdbior(null);
          /* Szarosc takze dla kafla bez rezerwacji (div albo odnosnik) -
             wylaczony przycisk zalatwia ja sam przez :disabled. */
          const punkt = kafel.querySelector('.dcheck-point');
          if (punkt) punkt.classList.toggle('dcheck-point--brak', !ma);
          const dopisek = kafel.querySelector('[data-point-stock]');
          if (dopisek) {
            /* Kazdy wzor z koszyka z „dostepny / niedostepny” - ten sam podzial
               co „Na stanie: ...” przy pozycjach w kroku 1. Bez danych zostaje
               ogolne zdanie, tylko przy magazynie bez kompletu. */
            if (!dopisek.dataset.ogolny) dopisek.dataset.ogolny = dopisek.textContent;
            const lista = czyMa && czyMa.pozycje ? czyMa.pozycje(kafel.dataset.pointCity) : [];
            if (lista.length) {
              dopisek.replaceChildren(
                ...lista.map(({ nazwa, dostepny }) => {
                  const wiersz = document.createElement('span');
                  wiersz.className = `dcheck-point__stock-item ${dostepny ? 'is-jest' : 'is-brak'}`;
                  wiersz.textContent = `${nazwa}: ${dostepny ? dopisek.dataset.labelYes : dopisek.dataset.labelNo}`;
                  return wiersz;
                }),
              );
              dopisek.hidden = false;
            } else {
              dopisek.textContent = dopisek.dataset.ogolny;
              dopisek.hidden = ma;
            }
          }
        });
        this.brakOdbioru = !kafle.length || (Boolean(czyMa) && !ktorykolwiek);
        this.brakKompletuAktywny = Boolean(czyMa) && !ktorykolwiek && kafle.length > 0;
        this.uzgodnijOdbior();
      };

      const numer = (this.numerStanow = (this.numerStanow || 0) + 1);
      ustaw(null);
      if (!this.trybWKoszyku || !kafle.length) return;
      const czyMa = await magazynyZKoszykiem();
      /* Klient mogl w tym czasie wrocic do listy albo wejsc w krok 2 drugi
         raz - liczy sie tylko ostatnie pytanie. */
      if (numer !== this.numerStanow || !this.trybWKoszyku) return;
      ustaw(czyMa);
    }

    /* Komunikaty o odbiorze zgodne z werdyktem dostawy:
       - „dowozimy” + zaden magazyn bez kompletu: czerwone zdanie o braku
         towaru znika - towar jest i przyjedzie, nie da sie go tylko odebrac
         (brzmialo jak „brak towaru”, audyt na slepo 27.10.2026);
       - „nie dowozimy” + odbioru nie ma: zdanie „ale mozesz odebrac” znika,
         a w kraju bez magazynu wchodzi zdanie z prosba o kontakt. */
    uzgodnijOdbior() {
      const brakKompletu = this.querySelector('[data-pickup-none]');
      if (brakKompletu) brakKompletu.hidden = !this.brakKompletuAktywny || this.werdyktOkna === 'tak';
      const tekstNie = this.querySelector('.dcheck-no__text');
      if (!tekstNie) return;
      if (!tekstNie.dataset.zwykly) tekstNie.dataset.zwykly = tekstNie.textContent;
      const bezOdbioru = this.trybWKoszyku && this.brakOdbioru;
      /* Szuflada chowa wtedy swoje „wybierz magazyn, zeby przejsc do kasy” -
         magazynu do wyboru nie ma, a co dalej mowi okno. */
      if (this.trybWKoszyku) this.dispatchEvent(new CustomEvent('dostawa:odbior-stan', { bubbles: true, detail: { brak: Boolean(bezOdbioru) } }));
      if (bezOdbioru && !this.brakKompletuAktywny && tekstNie.dataset.brak) {
        tekstNie.textContent = tekstNie.dataset.brak;
        tekstNie.hidden = false;
      } else {
        tekstNie.textContent = tekstNie.dataset.zwykly;
        tekstNie.hidden = Boolean(bezOdbioru);
      }
    }

    /* Powrot na swoje miejsce w layoucie. Wezel sasiada moze juz nie istniec
       (edytor motywu przerysowuje sekcje), wiec sprawdzamy to przed wstawieniem. */
    zKoszyka() {
      if (!this.trybWKoszyku) return;
      this.trybWKoszyku = false;
      this.oznaczMagazyny();
      this.hidden = true;
      this.classList.remove('dcheck--open', 'dcheck--booking');
      this.booking?.reset();
      const panel = this.panel;
      if (panel) {
        panel.setAttribute('aria-modal', 'true');
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('tabindex', '-1');
      }
      const dom = this.dom;
      if (!dom || !dom.rodzic || !dom.rodzic.isConnected) return;
      if (dom.przed && dom.przed.parentNode === dom.rodzic) {
        dom.rodzic.insertBefore(this, dom.przed);
      } else {
        dom.rodzic.appendChild(this);
      }
    }

    /* Czysta karta przed kolejnym pytaniem: bez werdyktu, bez kalendarza,
       z wlasnym naglowkiem. Kod pocztowy zostaje - klient wpisal go sam. */
    zresetuj() {
      if (this.querySelector('[data-pickup-choose].dcheck-point--wybrany')) this.wybierzOdbior(null);
      this.odpowiedziano = false;
      this.wymagaRezerwacji = false;
      this.trybRezerwacji = null;
      this.classList.remove('dcheck--booking');
      this.booking?.reset();
      this.przywrocNaglowek();
      this.wylaczPotwierdzenie();
      this.schowajBlad();
      if (this.wynik) this.wynik.hidden = true;
      if (this.wynikTak) this.wynikTak.hidden = true;
      if (this.wynikNie) this.wynikNie.hidden = true;
    }

    /* ---------- otwieranie i zamykanie ---------- */

    otworz(dalej) {
      if (this.trybWKoszyku) return;
      this.poZamknieciu = typeof dalej === 'function' ? dalej : null;
      this.odpowiedziano = false;
      this.wymagaRezerwacji = false;
      this.trybRezerwacji = null;
      this.classList.remove('dcheck--booking');
      this.booking?.reset();
      this.przywrocNaglowek();
      this.wylaczPotwierdzenie();
      this.hidden = false;
      this.zablokujPrzewijanie();
      // Podwojna klatka: przegladarka musi zdazyc policzyc stan zamkniety,
      // inaczej panel pojawi sie bez animacji wysuwania.
      requestAnimationFrame(() => requestAnimationFrame(() => {
        this.classList.add('dcheck--open');
        if (this.panel) this.panel.focus();
      }));
    }

    zamknij() {
      /* W kroku 2 szuflady okno nie ma czego zamykac - krokami steruje
         szuflada, a jej krzyzyk zamyka cala szuflade. */
      if (this.trybWKoszyku || this.hidden) return;
      window.clearTimeout(this.zegarPotwierdzenia);
      if (!this.wymagaRezerwacji || this.odpowiedziano) zapamietaj();
      this.classList.remove('dcheck--open', 'dcheck--booking');
      this.booking?.reset();
      this.odblokujPrzewijanie();

      /* Zamkniecie bez werdyktu = rezygnacja: akcja czekajaca za oknem
         przepada. Po werdykcie (takze „nie dowozimy" - to informacja, nie
         blokada) akcja idzie dalej. */
      const dalej = this.odpowiedziano ? this.poZamknieciu : null;
      this.poZamknieciu = null;
      this.odpowiedziano = false;

      const koniec = () => {
        if (this.hidden) return;
        this.hidden = true;
        if (dalej) dalej();
      };

      if (this.panel) {
        this.panel.addEventListener('transitionend', koniec, { once: true });
        window.setTimeout(koniec, 400);
      } else {
        koniec();
      }
    }

    zablokujPrzewijanie() {
      if (this.zablokowane) return;
      this.zablokowane = true;
      window.dizzBlokadaTla?.zablokuj(this.panel || this);
    }

    odblokujPrzewijanie() {
      if (!this.zablokowane) return;
      this.zablokowane = false;
      window.dizzBlokadaTla?.odblokuj();
    }

    /* Przeciagniecie uchwytu w dol zamyka arkusz - ten sam gest co w szufladzie
       koszyka i w arkuszu „Podaj ilosc". Uchwyt jest tylko na telefonie. */
    podepnijPrzeciaganieUchwytu() {
      const PROG_ZAMKNIECIA = 80;
      let startY = 0;
      let deltaY = 0;
      let przeciaga = false;

      const naRuch = (zdarzenie) => {
        const panel = this.panel;
        if (!przeciaga || !panel) return;
        deltaY = Math.max(0, zdarzenie.clientY - startY);
        panel.style.transform = `translateY(${deltaY}px)`;
      };

      const naKoniec = () => {
        if (!przeciaga) return;
        przeciaga = false;
        if (this.panel) {
          this.panel.classList.remove('dcheck__panel--przeciagane');
          this.panel.style.transform = '';
        }
        if (deltaY > PROG_ZAMKNIECIA) this.zamknij();
        deltaY = 0;
      };

      this.addEventListener('pointerdown', (zdarzenie) => {
        if (!zdarzenie.target.closest('.dcheck__handle') || !this.panel) return;
        przeciaga = true;
        startY = zdarzenie.clientY;
        deltaY = 0;
        this.panel.classList.add('dcheck__panel--przeciagane');
        this.setPointerCapture(zdarzenie.pointerId);
      });
      this.addEventListener('pointermove', naRuch);
      this.addEventListener('pointerup', naKoniec);
      this.addEventListener('pointercancel', naKoniec);
    }
  }

  if (!customElements.get('delivery-check')) {
    customElements.define('delivery-check', DeliveryCheck);
  }
})();
